import { playersTypes } from '../constants/playersConstants';

const loadPlayers = (owner, participants) => ({
    type: playersTypes.LOAD_PLAYERS,
    owner,
    participants
});

const addPlayers = (player) => ({
    type: playersTypes.ADD_PLAYERS,
    player
});

const setOnline = (player) => ({
    type: playersTypes.SET_ONLINE,
    player
});

const setOffline = (player) => ({
    type: playersTypes.SET_OFFLINE,
    player
});

export default {
    addPlayers,
    loadPlayers,
    setOnline,
    setOffline
};